const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0.0 -0.1 250.9 213.8",
    zoomAndPan: "magnify",
    style: {
      fill: "rgb(0, 0, 0)"
    },
    original_string_length: 1652,
    width: "42.952480053224356px",
    height: "36.62675117265859px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "__id11_son29lvk7l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.51,200.03c2.17.02,3.95-1.72,3.97-3.89,0-.09,0-.18,0-.27,0-2.95-1.78-4.35-5.42-4.35h-5.89v15.42h2.22v-6.72h2.72l.06.08,4.23,6.64h2.37l-4.55-6.87.3-.04ZM235.95,198.48h-2.57v-5.21h3.26c1.68,0,3.6.28,3.6,2.48,0,2.53-1.94,2.74-4.3,2.74",
    "data-name": "Path 2525",
    style: {
      fill: "rgb(55, 55, 55)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "__id12_son29lvk7l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.7,180.7h-31.42v-49.21c0-11.73-.21-26.84-16.34-26.84s-18.87,12.79-18.87,25.99v50.06h-31.42v-101.2h30.17v13.83h.42c6.15-10.52,17.59-16.8,29.76-16.35,31.85,0,37.72,20.95,37.72,48.2v55.52ZM47.18,65.67c-10.07,0-18.24-8.16-18.24-18.23,0-10.07,8.16-18.24,18.23-18.24,10.07,0,18.24,8.16,18.24,18.23,0,10.07-8.16,18.24-18.23,18.24h0M62.9,180.7h-31.46v-101.2h31.46v101.2ZM196.37.01H15.65C7.11-.08.1,6.76,0,15.3v181.47c.1,8.55,7.1,15.39,15.65,15.3h180.72c8.56.11,15.59-6.74,15.71-15.3V15.29C211.96,6.73,204.93-.11,196.37,0",
    "data-name": "Path 2520",
    style: {
      fill: "rgb(55, 55, 55)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "__id13_son29lvk7l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.21,184.65c-7.99.08-14.4,6.61-14.32,14.6.08,7.99,6.61,14.4,14.6,14.32,7.99-.08,14.4-6.61,14.32-14.6-.08-7.88-6.44-14.25-14.32-14.32h-.28M236.21,211.92c-7,.12-12.77-5.47-12.89-12.47s5.47-12.77,12.47-12.89c7-.12,12.77,5.47,12.89,12.47v.21c.15,6.85-5.29,12.52-12.14,12.67h-.33",
    "data-name": "Path 2526",
    style: {
      fill: "rgb(55, 55, 55)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.834eab0a2d588cf18c45075491d880df.svg";
export { ForwardRef as ReactComponent };